import { useTranslation } from "react-i18next";

import { useHasKey } from "../components/useHasKey";

/**
 * One idea, set as a two-column band rather than as a numbered section: heading on one side,
 * the paragraph on the other. It is the only place on the page with that shape, which is
 * what makes it land — it interrupts the rhythm of the sections around it.
 */
export function Identity() {
  const { t } = useTranslation();
  const has = useHasKey();

  if (!has("identity.heading")) return null;

  return (
    <section className="band" id="identity">
      <h2 className="band__heading">{t("identity.heading")}</h2>
      {has("identity.body") ? <p className="band__body">{t("identity.body")}</p> : null}
    </section>
  );
}
